import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export function NoResultFound() {
  const { t: translation } = useTranslation();

  return (
    <Stack direction="row" gap={2} alignItems="center" justifyContent="center">
      <SearchOffOutlinedIcon
        sx={theme => ({
          fontSize: 18,
          color: theme.brandPalette.foreground.neutralFaded
        })}
      />
      <Typography
        variant="labelSmall"
        sx={theme => ({
          fontWeight: 400,
          fontSize: 14,
          textAlign: 'center',
          color: theme.brandPalette.foreground.neutralFaded
        })}
      >
        {translation('components.noResultFound.title')}{' '}
        {translation('components.noResultFound.message')}
      </Typography>
    </Stack>
  );
}
